import React from "react";

export type CSStackContextData = {
  userPermissions: string[]
}
const defaultValue: CSStackContextData = {
  userPermissions: []
}
export const CSStackContext = React.createContext<CSStackContextData>(defaultValue)